import { Box } from "@chakra-ui/react";

import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingContactWidget } from "./FloatingContactWidget";


interface IProps {
	children: JSX.Element;
}

export const MarketingLayout = ({ children }: IProps): JSX.Element => {
	return (
		<Box
			width="100%"
			minH="100vh"
			bg="white"
			pt={{ base: "72px", lg: "88px" }}
		>
			<Navbar />
			{children}
			<Footer />
			<FloatingContactWidget />
		</Box>
	);
};
